<template>
  <div>
    <BaseLoader :loading="loading"/>

    <div v-if="!loading && dataset1.length" class="graph-wrapper">
      <div class="ferm-times">

        <div class="form-check form-check-inline" v-for="item in [7, 14, 21, 28]">
          <input class="form-check-input"
                 type="radio"
                 :name="'days-radio-' + id"
                 v-model="days"
                 :id="id + '-' + item"
                 :value="item">
          <label class="form-check-label" :for="id + '-' + item">
            {{item}} days
          </label>
        </div>
      </div>
      <LineChart  :unique-id="brewSessionId"
                  :dataset-y1='dataset1'
                  :dataset-y2='dataset2'
      ></LineChart>
    </div>
    <div v-if="!loading && dataset1.length === 0">
      <small>No fermentation data added</small>
    </div>

  </div>
</template>

<script>
    import { EventBus } from '@/lib/event-bus.js';
    import { HTTP } from '../lib/http';
    import LineChart from "../components/charts/LineChart";

    export default {
        props: {
            brewSessionId: { type: Number }
        },
        components: {
          LineChart
        },
        data() {
            return {
                id: null,
                recipes: undefined,
                errors: null,
                loading: true,
                days: 14,
                dataset1: [],
                dataset2: null,
            };
        },
        watch: {
            days: function (newVal, oldVal) {
                this.loading = true;
                this.fetchStreamData();
            }
        },
        methods: {
            fetchStreamData() {
              this.loading = true;
                HTTP
                    .get("brew-sessions/" + this.brewSessionId + "/stream?filter[days]=" + this.days)
                    .then(response => {
                        this.dataset1 = response.data.data.map(function (x) { return { x: new Date(x.timestamp), y: x.sg } });
                        this.dataset2 = response.data.data.map(function (x) { return { x: new Date(x.timestamp), y: x.temperature[1].val } });
                    })
                    .catch(err => {
                        this.errors = [err.response.data.message];
                    })
                    .then(() => {
                        this.loading = false;
                    });
            }
        },
        created() {
            this.fetchStreamData();
        },
        mounted() {
          EventBus.$on(`brew-session-data-changed:${this.brewSessionId}`, this.fetchStreamData);
            this.id = this._uid;
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .ferm-times {
    display: flex;
    justify-content: space-evenly;

    input,
    label {
      cursor: pointer;
    }
  }
</style>
